import Img1 from "../../assets/ImageGallery/1.jpeg";
import Img2 from "../../assets/ImageGallery/2.jpeg";
import Img3 from "../../assets/ImageGallery/3.jpeg";
import Img4 from "../../assets/ImageGallery/4.jpeg";
import Img5 from "../../assets/ImageGallery/5.jpeg";
import Img6 from "../../assets/ImageGallery/6.png";
import Img7 from "../../assets/ImageGallery/7.png";
import Img8 from "../../assets/ImageGallery/8.png";
import Img9 from "../../assets/ImageGallery/9.png";
import Img10 from "../../assets/ImageGallery//10.png";

export const IMAGE_DATA = [
  {
    id: 1,
    image: Img1,
  },
  {
    id: 2,
    image: Img2,
  },
  {
    id: 3,
    image: Img3,
  },
  {
    id: 4,
    image: Img4,
  },
  {
    id: 5,
    image: Img5,
  },
  {
    id: 6,
    image: Img6,
  },
  {
    id: 7,
    image: Img7,
  },
  {
    id: 8,
    image: Img8,
  },
  {
    id: 9,
    image: Img9,
  },
  {
    id: 10,
    image: Img10,
  },
];
